/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as TYPES from './action-types';
import _ from 'lodash';
import axios from 'axios';
import * as serviceEndPoint from './../../../../../SharedModules/services/service';

export const setTransitionDataInvoicesLoading = (payload) => {
  return {
    type: TYPES.TRANSITION_DATA_INVOICE_LOADING,
    payload,
  };
};

export const setTransitionDataClaimDetail = (payload) => {
  return {
    type: TYPES.TRANSITION_DATA_CLAIM_DETAILS,
    payload,
  };
};

export const setTransitionInvoicesData = (payload) => {
  return {
    type: TYPES.TRANSITION_DATA_INVOICE_DATA,
    payload,
  };
};

export const setSateData = (payload) => {
  return {
    type: TYPES.TRANSITION_DATA_STATE_DATA,
    payload,
  };
};

export const setComponentData = (payload) => {
  return {
    type: TYPES.TRANSITION_DATA_COMPONENT_STATE,
    payload,
  };
};

export const setErrorMessages = (payload) => {
  return {
    type: TYPES.SET_ERROR_MESSAGES,
    payload,
  };
};

export const setSuccessMessages = (payload) => {
  return {
    type: TYPES.SET_SUCCESS_MESSAGES,
    payload,
  };
};

export const setSelectType = (payload) => {
  return {
    type: TYPES.SET_SELECT_TYPE,
    payload,
  };
};

export const setPlanType = (payload) => {
  return {
    type: TYPES.SET_PLAN_TYPE,
    payload,
  };
};

export const setRebateProgram = (payload) => {
  return {
    type: TYPES.SET_REBATE_PROGRAM,
    payload,
  };
};

export const setStartDate = (payload) => {
  return {
    type: TYPES.SET_START_DATE,
    payload,
  };
};

export const setEndDate = (payload) => {
  return {
    type: TYPES.SET_END_DATE,
    payload,
  };
};

export const setErrors = (payload) => {
  return {
    type: TYPES.SET_ERRORS,
    payload,
  };
};

export const setRbtPrgDD = (payload) => {
  return {
    type: TYPES.SET_REBATE_PROGRAM_DD,
    payload,
  };
};

export const resetTransitionDataStore = () => {
  return {
    type: TYPES.RESET_TRANSITION_DATA_STORE,
  };
};

export const getTransitionDataClaimDetail = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.TRANSITION_DATA_GET_CLAIM_DETAILS_URL}`, values)
    .then((response) => {
      return dispatch(setTransitionInvoicesData(response.data));
    })
    .catch(() => {
      dispatch(setTransitionInvoicesData(null));
    });
};

export const getTransitionInvoiceList = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.TRANSITION_DATA_INVOICE_DATA_URL}`, values)
    .then((response) => {
      return dispatch(setTransitionInvoicesData(response.data));
    })
    .catch(() => {
      dispatch(setTransitionInvoicesData(null));
    });
};
export const getStateData = () => (dispatch) => {
  return axios
    .get(`${serviceEndPoint.TRANSITION_DATA_GET_RPC}`)
    .then((response) => {
      var ddValue = [];
      //response.data.map((item) => ddValue.push({ value: item, name: item }));
      const data = response?.data?.split(',') || [];
      data.forEach((item) => {
        ddValue.push({ value: item, label: item });
      });
      return dispatch(setSateData(ddValue));
    })
    .catch(() => {
      dispatch(setSateData(null));
    });
};
